import { render, staticRenderFns } from "./ChatCardCreateTask.vue?vue&type=template&id=6cba6224&scoped=true"
import script from "./ChatCardCreateTask.vue?vue&type=script&lang=js"
export * from "./ChatCardCreateTask.vue?vue&type=script&lang=js"
import style0 from "./ChatCardCreateTask.vue?vue&type=style&index=0&id=6cba6224&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cba6224",
  null
  
)

export default component.exports